module.exports = __webpack_public_path__ + "static/media/ruzencova-lide2.753291da.jpg";